<template>
  <article class="page-project-service">
    <!-- table panel -->
    <crm-panel class="table-panel">
      <!-- total time -->
      <section class="tips-container">
        <span class="tips-container_text">数据统计于{{ totalTime }}</span>
      </section>
      <!-- toolbar -->
      <section class="select-container">
        <el-form :inline="true">
          <span class="select-container_label">项目服务量统计</span>
          <el-form-item>
            <el-select
              v-model="timeRangeAlias"
              @change="handleTimeRangeChange($event)"
            >
              <chart-total-time-options />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-show="isShown"
              v-model="time"
              value-format="yyyy-MM-dd"
              :editable="false"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <cusname-select
              :customSelectSearch="customSelectSearch"
              :val="tableSearchForm.customerId"
              @change="handleCusNameChange"
            >
            </cusname-select>
          </el-form-item>
          <el-form-item> </el-form-item>
        </el-form>
        <div class="select-container_buttons">
          <crm-button
            v-if="
              auth.sdProjectServiceStatisticsDownload &&
                auth.sdProjectServiceStatisticsDownload.toggleStatus
            "
            buttonType="plain"
            text="导出"
            @click="handleExport()"
          >
          </crm-button>
        </div>
      </section>
      <!-- total block -->
      <section class="total-container">
        <div
          class="total-container_block"
          v-for="totalBlock in totalBlockList"
          :key="totalBlock.tipText"
        >
          <crm-block v-bind="totalBlock" />
        </div>
      </section>
      <!-- table -->
      <el-table
        :data="tableData.results"
        border
        v-loading="loading"
        height="100%"
        style="width: 100%"
      >
        <el-table-column
          fixed
          show-overflow-tooltip
          prop="customerName"
          width="200"
          label="客户名称"
          align="center"
        >
        </el-table-column>
        <el-table-column
          fixed
          show-overflow-tooltip
          prop="projectName"
          width="120"
          label="项目名称"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="onlineDate"
          width="120"
          label="上线时间"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="offlineDate"
          width="120"
          label="下线时间"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="totalService" label="服务总量" align="center">
        </el-table-column>
        <el-table-column
          prop="newContractNumberStr"
          label="电话咨询"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.service['电话咨询'] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="newContractNumberStr"
          label="预约挂号"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.service['预约挂号'] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="newContractNumberStr"
          label="图文问诊"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.service['图文问诊'] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="newContractNumberStr"
          label="二次诊疗"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.service['二次诊疗'] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="newContractNumberStr"
          label="复诊预约"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.service['复诊预约'] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="newContractNumberStr"
          label="绿通服务"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.service['绿通服务'] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="newContractNumberStr"
          label="远程问诊"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.service['远程问诊'] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="newContractNumberStr"
          label="营养方案"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.service['营养方案'] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="newContractNumberStr"
          label="转诊预约"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.service['转诊预约'] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="newContractNumberStr"
          label="陪同就诊"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.service['陪同就诊'] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="newContractNumberStr"
          label="住院探视"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.service['住院探视'] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="newContractNumberStr"
          label="问诊开药"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.service['问诊开药'] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="newContractNumberStr"
          label="健康评估"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.service['健康评估'] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="newContractNumberStr"
          label="放号提醒"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.service['放号提醒'] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="newContractNumberStr"
          label="客服电话"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.service['客服电话'] }}
          </template>
        </el-table-column>
        <el-table-column
          prop="serviceCost"
          width="120"
          label="线下服务成本"
          align="center"
        >
        </el-table-column>
      </el-table>
      <!-- pageination -->
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="tableSearchForm.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="tableSearchForm.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="tableData.totalCount"
        >
        </el-pagination>
      </div>
    </crm-panel>
  </article>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import { serviceCount } from 'crm-common';

import { downloadByUrl, conversion } from '@/scripts/utils';
import http from '~services/axios';
import CHART_TOTAL_BLOCK_PROPS from '~services/constant/statistics/service-total-block';
import CHART_API_CONFIG from '~api/statistics/service-api-config';
import getTimeRangeByAlias from '~services/time-range';

import ChartTotalTimeOptions from '@/components/business/datastatistics/chart-total-time-options';
import CrmPanel from '@/components/base/crmPanel';
import CrmButton from '@/components/base/crmButton';
import CrmBlock from '@/components/base/crmBlock';
import CusnameSelect from '@/components/business/custom/cusname-select';

const { apiFactory, totalFactory, chartFactory: optionFactory } = serviceCount;
const diagramCommonApi = apiFactory(http, CHART_API_CONFIG);

// crm-common包中对每个图表定义的名称
const CHART_NAME = 'project';

// echarts instance
let chart;
const echartsConfig = {
  devicePixelRatio: window.devicePixelRatio,
};
const defaultDataFormat = 'YYYY-MM-DD';

export default {
  components: {
    CrmPanel,
    CrmButton,
    CrmBlock,
    ChartTotalTimeOptions,
    CusnameSelect,
  },
  filters: {
    conversion,
  },
  data() {
    const yestoday = moment()
      .dates(moment().date() - 1)
      .format(defaultDataFormat);

    return {
      loading: false,
      isShown: false,
      time: [],
      totalTime: yestoday,
      timeRangeAlias: 'this-month',
      totalBlockList: [],
      tableData: {
        results: [],
        totalCount: 1,
      },
      tableSearchForm: {
        startDate: moment()
          .startOf('month')
          .format(defaultDataFormat),
        endDate: moment()
          .endOf('month')
          .format(defaultDataFormat),
        customerId: null,
        pageNumber: 1,
        pageSize: 10,
      },
    };
  },
  computed: {
    ...mapGetters('authority', {
      auth: 'auth',
    }),
  },
  watch: {
    time: {
      handler: 'handleSelfTimeSearch',
    },
  },
  mounted() {
    this.getDiagram();
  },
  methods: {
    ...mapActions({
      customSelectSearch: 'statistics/customSelectSearch',
    }),
    renderTotalTime() {
      this.totalTime = moment()
        .dates(moment().date() - 1)
        .format(defaultDataFormat);
    },
    handleTimeRangeChange(timeAlias) {
      if (timeAlias === 'self-time') {
        this.isShown = true;
      } else {
        this.isShown = false;
        const { startTime, endTime } = getTimeRangeByAlias(
          timeAlias,
          defaultDataFormat,
        );
        this.tableSearchForm = {
          ...this.tableSearchForm,
          startDate: startTime,
          endDate: endTime,
        };
        this.getDiagram();
      }
    },
    handleSelfTimeSearch() {
      this.tableSearchForm = {
        ...this.tableSearchForm,
        startDate: this.time[0],
        endDate: this.time[1],
      };
      this.getDiagram();
    },
    // handleTimeRangeChange(timeAlias) {
    //   const { startTime, endTime } = getTimeRangeByAlias(timeAlias, defaultDataFormat);
    //   this.tableSearchForm = {
    //     ...this.tableSearchForm,
    //     startDate: startTime,
    //     endDate: endTime,
    //   };
    //   this.getDiagram();
    // },
    renderTotalBlock(data) {
      // total: [{ key: 'totalOrder', value: 100, alias: '总订单量' }, {}, ...]
      const total = totalFactory(CHART_NAME, data);
      this.totalBlockList = total.map(({ key, value }) => {
        const totalComponentProps = CHART_TOTAL_BLOCK_PROPS[key];
        totalComponentProps.theme = value;
        return totalComponentProps;
      });
    },
    renderTable(data) {
      this.tableData = data;
    },
    // chart ajax
    getDiagram() {
      diagramCommonApi(CHART_NAME, this.tableSearchForm).then((res) => {
        const { data, totalOrder } = res.data;
        this.renderTotalTime();
        this.renderTotalBlock({ totalOrder });
        this.renderTable(data);
      });
    },
    handleSizeChange(val) {
      this.tableSearchForm.pageSize = val;
      this.tableSearchForm.pageNumber = 1;

      this.getDiagram();
    },
    handleCurrentChange(val) {
      this.tableSearchForm.pageNumber = val;
      this.getDiagram();
    },
    handleExport() {
      const params = this.tableSearchForm;
      this.notify = this.$notify({
        iconClass: 'el-icon-loading',
        title: '',
        message: '正在导出中，请稍后...',
        duration: 0,
        showClose: false,
      });

      let url = '/api/serviceData/download/projectService/statistics?';
      Object.keys(params).forEach((item) => {
        if (params[item]) url += `${item}=${params[item]}&`;
      });

      downloadByUrl(url);
      if (this.notify) this.notify.close();
    },
    handleCusNameChange(value) {
      this.tableSearchForm.customerId = value;
      this.getDiagram();
    },
  },
};
</script>

<style lang="less" scoped>
.page-project-service {
  display: flex;
  flex: 1;
  width: 100%;

  // 表格面板
  .table-panel {
    .tips-container {
      margin: -20px -20px 0;
      background: rgba(240, 183, 98, 0.1);
      height: 28px;
      line-height: 28px;
      &_text {
        padding-left: 20px;
        color: #7a84b7;
      }
    }
    .select-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      &_label {
        line-height: 42px;
        font-size: 24px;
        color: #7a84b7;
        padding-right: 30px;
      }
    }
    .total-container {
      display: flex;
      flex-wrap: wrap;
      &_block {
        margin-left: 20px;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
